import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

import { getFormatMedia } from "~/theme/utils";

import { LINKED_STORE_CARD_CLASSES } from "./constants";

export const LinkedStoreCardContainer = styled(Box)(({ theme }) => {
  const { BREAKPOINT_DESKTOP } = getFormatMedia(theme);

  return {
    paddingRight: 0,
    height: "100%",

    [`& .${LINKED_STORE_CARD_CLASSES.button}`]: {
      height: "100%",
      padding: 0,

      "&:after": {
        borderWidth: 0,
      },
      "&:active, &:active, &:hover": {
        backgroundColor: "transparent !important",
        "&:after": {
          [BREAKPOINT_DESKTOP]: {
            borderWidth: 2,
          },
        },
      },
      "&:before": {
        content: "none",
        display: "none",
      },
    },

    [`& .${LINKED_STORE_CARD_CLASSES.buttonLabel}`]: {
      display: "block",
      textTransform: "none",
      height: "100%",
      width: "100%",
      position: "relative",
    },

    [`& .${LINKED_STORE_CARD_CLASSES.storeCard}`]: {
      maxWidth: "100%",
      height: "100%",
    },
  };
});
